import { faSave, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { useFormikContext } from 'formik'
import React from 'react'
import { Input, DatePicker } from 'src/components/Forms'
import { Body, Footer } from 'src/components/theme/Models/Modal'
import { Values } from './FormContext'
import YesNo from 'src/components/Forms/YesNo'

interface FormProps {
  toggle: () => void
  isLoading?: boolean
  hasError?: boolean
  disableSave?: boolean
}

const Form: React.FC<FormProps> = (props) => {
  const { hasError, toggle, isLoading, disableSave } = props
  const { handleSubmit } = useFormikContext<Values>()
  return (
    <>
      <Body error={{
        error: 'There was an issue updating the MSA Information.',
        show: hasError ?? false
      }}
      >
        <DatePicker name='staffingAgency.msa.dateSigned' label='Date MSA Signed' />
        <Input type='text' name='staffingAgency.msa.conversionTimeframe' label='Conversion Timeframe' />
        <Input type='text' name='staffingAgency.msa.conversionFees' label='Conversion Fees' />
        <YesNo name='staffingAgency.msa.dhAvailable' label='DH Available' />
        <Input type='text' name='staffingAgency.msa.dhWarranty' label='Warranty On DH' />
        <Input type='text' name='staffingAgency.msa.nonSolicitationDuration' label='Non-Solicitation Duration' />
      </Body>
      <Footer
        toggle={toggle}
        onAction={handleSubmit}
        action={{
          text: 'Save',
          icon: isLoading === true ? faSpinner : faSave,
          color: 'primary',
          disabled: disableSave === true || isLoading
        }}
      />
    </>
  )
}

export default Form
